import { useMemo } from 'react';
import { CheckboxField, useControlledField } from '@frontend/design-system';
import { useBulkCollectionSelectAllShallowStore } from '../../../store/bulk-collections-select-all-store';
import { CollectionColumn } from './generate-columns';

export const RowSelect = ({ balance }: { balance: CollectionColumn }) => {
  const {
    isAllSelected,
    filters: selectAllFilters,
    included,
    excluded,
    handleSelection,
  } = useBulkCollectionSelectAllShallowStore('isAllSelected', 'filters', 'included', 'excluded', 'handleSelection');

  const handleChange = (val: boolean) => {
    handleSelection(val, balance.patientId);
  };

  const isDisabled = useMemo(() => {
    if (!balance.phoneNumber || balance.locationIds.length > 1) return true;
    return false;
  }, [balance.phoneNumber, balance.locationIds.length]);

  const isChecked = useMemo(() => {
    if (isDisabled) return false;
    const fullName = `${balance.firstName} ${balance.lastName}`;

    if (excluded.includes(balance.patientId)) return false;
    if (included.includes(balance.patientId)) return true;
    if (!isAllSelected) return false;

    const matchesBalanceType =
      selectAllFilters.balanceType.length === 0 || selectAllFilters.balanceType.includes(balance.balanceType);
    const searchLower = selectAllFilters.searchValue.trim().toLowerCase();
    const matchesSearch =
      searchLower.length === 0 ||
      fullName.toLowerCase().includes(searchLower) ||
      (balance.patientId ?? '').toLowerCase().includes(searchLower) ||
      (balance.phoneNumber ?? '').toLowerCase().includes(searchLower);

    return matchesBalanceType && matchesSearch;
  }, [
    isDisabled,
    excluded,
    included,
    isAllSelected,
    selectAllFilters,
    balance.patientId,
    balance.balanceType,
    balance.firstName,
    balance.lastName,
  ]);

  const selectProps = useControlledField({
    onChange: handleChange,
    type: 'checkbox',
    value: !!isChecked,
  });

  return <CheckboxField {...selectProps} disabled={isDisabled} name='select-bal' label='' indeterminate={false} />;
};
